import React, { useEffect, useMemo } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';

function LineChartStats({eventSeriesData, submissionsInsideEvent,dateRange}) {
  //console.log("Submissions Inside Event:", submissionsInsideEvent);

 

  // Process submissions data to count by day
  const filterSubmissionsByDate = useMemo(() => {
    // Check if submissionsInsideEvent is not empty and has the expected structure
    if (!dateRange || !submissionsInsideEvent ) {
      return [];
    }

    const currentDate = new Date(dateRange.startDate);
   
    const endDate = new Date(dateRange.endDate);
    const dates = []

    //If the date range is invalid, return an empty array
    while (currentDate <= endDate) {

      //Get the date format to 2023-10-01 by splitting the date string before the T
      const dayKey = currentDate.toISOString().split('T')[0];

      //Get the day label in the format of 1 Oct
      const dayLabel = `${currentDate.getDate()} ${currentDate.toLocaleString('default', { month: 'short' ,weekday: 'short'})}`;
      
      //Add start date
      //Add label
      //Add date format
      //Add count
      dates.push({
        fullDate: new Date(currentDate),
        day: dayLabel,
        dayKey: dayKey,
        count: 0
      });
      
      //Go to next day until the end date is reached
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    return dates;
  }, [dateRange]);


  //Set the date to be shown by day
  const dailyData = useMemo(() => {
    if (!filterSubmissionsByDate.length || !submissionsInsideEvent) return [];
    
    // Create a map for quick access
    const countsMap = filterSubmissionsByDate.reduce((acc, date) => {
      acc[date.dayKey] = { ...date };
      return acc;
    }, {});
    
    // Track unique submission IDs to avoid counting duplicates
    const countedSubmissions = new Set();
    
    // Process all submissions
    submissionsInsideEvent.forEach(item => {
    
        item.submissions.submissions.forEach(submission => {
         
          const submissionId = submission.id 
          
          // Skip if we've already counted this submission
          if (countedSubmissions.has(submissionId)) {
            return;
          }
          
          if (submission.submitted_at) {
            const date = new Date(submission.submitted_at);
            const dayKey = date.toISOString().split('T')[0];
            
            if (countsMap[dayKey]) {
              countsMap[dayKey].count++;
              countedSubmissions.add(submissionId);
            }
          }
        });
      
    });

    // Return the array with all dates in the range
    return Object.values(countsMap);
  }, [submissionsInsideEvent, filterSubmissionsByDate]);




  return (
    <div className="bg-white p-4 rounded-lg shadow">
      
      {dailyData.length > 0 ? (
        <LineChart
          width={500}
          height={300}
          series={[
            {
              data: dailyData.map(item => item.count),
              label: 'Submissions',
              curve: 'linear',
              color: '#4f46e5',
            }
          ]}
          xAxis={[
            {
              scaleType: 'point',
              data: dailyData.map(item => item.day),
              tickLabelStyle: {
                angle: 45,
                textAnchor: 'start',
                fontSize: 12
              }
            }
          ]}
          slotProps={{
            legend: { 
              hidden: false,
              position: { vertical: 'top', horizontal: 'right' } 
            }
          }}
        />
      ) : (
        <div className="flex justify-center items-center h-64 text-gray-500">
          No submission data available
        </div>
      )}
    </div>
  );
}

export default LineChartStats;